// Size helpers shared by the Shop filter and the Concierge, so both reflect the
// sizes that actually exist in the catalogue instead of a hard-coded list.

// Canonical order for apparel letter sizes; anything unknown sorts after.
const ALPHA_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "XXXL", "3XL", "4XL", "5XL"];

// Sort a mixed list of sizes: numeric footwear ascending, then apparel letters
// in wearing order, then anything else (e.g. "One Size", "Free") alphabetically.
export function sortSizes(list) {
  const uniq = [...new Set((list || []).map((s) => String(s).trim()).filter(Boolean))];
  return uniq.sort((a, b) => {
    const na = parseFloat(a), nb = parseFloat(b);
    const aNum = /^\d/.test(a) && !Number.isNaN(na);
    const bNum = /^\d/.test(b) && !Number.isNaN(nb);
    if (aNum && bNum) return na - nb;
    if (aNum) return -1;
    if (bNum) return 1;
    const ia = ALPHA_ORDER.indexOf(a.toUpperCase());
    const ib = ALPHA_ORDER.indexOf(b.toUpperCase());
    if (ia !== -1 && ib !== -1) return ia - ib;
    if (ia !== -1) return -1;
    if (ib !== -1) return 1;
    return a.localeCompare(b);
  });
}

// Distinct, sorted sizes present across a list of products.
export function distinctSizes(products) {
  const all = [];
  (products || []).forEach((p) => (p.sizes || []).forEach((s) => all.push(s)));
  return sortSizes(all);
}
